import { AIButtonIconGradientSvgPlacement } from './AIButton.constants'

export function isAIButtonIconGradientSvgPlacementOffscreen(placement) {
  return placement === AIButtonIconGradientSvgPlacement.Offscreen
}

export function getAIButtonIconGradientStyleVars(gradientId) {
  return {
    '--ai-icon-gradient': `url(#${gradientId})`,
  }
}
